// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__2L3o_","logo__small":"logo__small__3UYON"};